import { z } from 'zod'
import {
  Address,
  HexNumber,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { ProfileAddress } from '../../../ProfileAddress'

export const ProfileAddressSchema = z.string()

type ProfileAddressReportText = z.infer<typeof ProfileAddressSchema>

export function mapDomainToReportText(
  profileAddress: ProfileAddress
): ProfileAddressReportText {
  return profileAddress.getChecksumValue()
}

export function mapReportTextToDomain(
  reportText: ProfileAddressReportText
): ProfileAddress {
  return ProfileAddress.create({
    profileAddressValue: Address.create({
      addressValue: HexNumber.create({ hexNumberValue: reportText }),
    }),
  })
}
